import { FieldOption } from '@/forms/types/field-option';
import { FormSchema } from '@/forms/types/schema';
import { mergeSchemaAndValues } from '@/forms/utils/merge-schema-and-values';
import { GroupFieldValues } from './field-values';

const baseSchema = () => ({
  groupName: {
    type: 'text' as const,
    label: 'Group Name',
    placeholder: 'Enter group name',
    value: '',
    validation: { required: true, maxLength: 100 },
  },
  organisationId: {
    type: 'select' as const,
    label: 'Organisation',
    value: undefined as number | undefined,
  },
});

export const buildGroupFormSchema = (
  {
    canAssignAnyOrganisation,
    organisationName,
    organisationOptions,
  }: {
    canAssignAnyOrganisation: boolean;
    organisationName: string;
    organisationOptions: FieldOption<number>[];
  },
  values?: GroupFieldValues,
): FormSchema<GroupFieldValues> => {
  const schema = values
    ? mergeSchemaAndValues(baseSchema(), values)
    : baseSchema();

  if (canAssignAnyOrganisation) {
    schema.organisationId = {
      ...schema.organisationId,
      options: organisationOptions,
      validation: { required: true },
    };
  } else {
    schema.organisationId = {
      ...schema.organisationId,
      type: 'readonly',
      value: organisationName,
    };
  }

  return schema;
};
